import React from "react";
import { Tag } from "antd";
import { bookingStatusLabels, BookingStatus } from "../../types/booking";
import { statusColors } from "../../utils/bookingStatus";
import {
  formatContainerStatusLabel,
  getContainerStatusColor,
} from "../../utils/containerStatusColors";

export const normalizeAgentBookingStatus = (status: string): string =>
  status.replace(/-/g, "_");

export const AgentBookingStatusTag: React.FC<{
  status: string;
  label?: string;
  style?: React.CSSProperties;
}> = ({ status, label, style }) => {
  const key = normalizeAgentBookingStatus(status) as BookingStatus;
  return (
    <Tag color={statusColors[key] || "default"} style={{ margin: 0, ...style }}>
      {label ?? bookingStatusLabels[key] ?? status}
    </Tag>
  );
};

export const AgentContainerStatusTag: React.FC<{
  status: string | null | undefined;
  label?: string;
  style?: React.CSSProperties;
}> = ({ status, label, style }) => (
  <Tag color={getContainerStatusColor(status)} style={{ margin: 0, ...style }}>
    {label ?? formatContainerStatusLabel(status)}
  </Tag>
);

type SelectLabelProps = { value: string | number; label?: React.ReactNode };

export const renderAgentBookingStatusOption = (option: {
  value?: string | number;
  label?: React.ReactNode;
}) => (
  <AgentBookingStatusTag
    status={String(option.value ?? "")}
    label={option.label != null ? String(option.label) : undefined}
  />
);

export const renderAgentBookingStatusLabel = (props: SelectLabelProps) => (
  <AgentBookingStatusTag
    status={String(props.value)}
    label={props.label != null ? String(props.label) : undefined}
  />
);

export const renderAgentContainerStatusOption = (option: {
  value?: string | number;
  label?: React.ReactNode;
}) => (
  <AgentContainerStatusTag
    status={String(option.value ?? "")}
    label={option.label != null ? String(option.label) : undefined}
  />
);

export const renderAgentContainerStatusLabel = (props: SelectLabelProps) => (
  <AgentContainerStatusTag
    status={String(props.value)}
    label={props.label != null ? String(props.label) : undefined}
  />
);
